import React from "react";
import { useNavigate } from "react-router";
import logo from "../../assets/Images/ES-new-Logo.png";
import { clearStore, getStoreValue } from "../../utils/store";

const Header = (props: { heading?: string }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    if (getStoreValue("source")) {
      navigate(`/?app=${getStoreValue("source")?.toString()}`);
    } else {
      navigate(
        getStoreValue("isAdmin") && JSON.parse(getStoreValue("isAdmin"))
          ? `/users/login`
          : `/`
      );
    }
    clearStore();
  };

  return (
    <header className="text-[#252572] relative z-0">
      <div className="flex items-center justify-between">
        <div>
          <img
            src={logo}
            alt="Excelsoft logo"
            className="md:h-16 sm:h-10 h-8 md:w-60"
          />
        </div>

        <div className="hidden sm:block lg:text-2xl font-semibold">
          <div>{props.heading}</div>
        </div>

        <div className="font-bold cursor-pointer md:h-16 sm:h-10 h-8 w-60 flex items-center justify-end">
          <i
            className="fa-solid fa-power-off text-[20px]"
            onClick={() => handleLogout()}
            onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
              if (event.key === "Enter") {
                handleLogout();
              }
            }}
            tabIndex={0}
            aria-label="Logout button to activate press enter"
          ></i>
        </div>
      </div>
      <div className="sm:hidden sm:absolute w-full text-align text-sm sm:text-lg lg:text-2xl font-semibold flex items-center justify-center ">
        <div>{props.heading}</div>
      </div>
    </header>
  );
};

export default Header;
